import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Icon from "assets/images/settings/billing2.svg";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import styled from "styled-components";
import { TextView } from "../../components";
import { getAllTransactions } from "../../services/api";
import { colors } from "../../utils";
import { ASSETS } from "../../utils/config";

const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 40px;
  height: 40px;
`;

const Content = styled.div`
  width: 100%;
  margin-top: 20px;
  position: relative;
`;

const TableWrapper = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  background-color: ${colors.background};
  padding: 8px 12px;
  font-size: 14px;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  color: ${colors.primary};
  margin-bottom: 10px;
`;

const TableCell = styled.td`
  padding: 5px 8px;
  font-size: 12px;
  font-family: "DM Sans", sans-serif;
  color: ${colors.primary};
`;

const TableRow = styled.tr`
  height: 36px;
`;

const DateCell = styled(TableCell)`
  width: 25%;
`;

const PlanCell = styled(TableCell)`
  width: 25%;
  text-transform: capitalize;
`;

const AmountCell = styled(TableCell)`
  width: 25%;
`;

const DownloadCell = styled(TableCell)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DownloadIcon = styled.img`
  width: 12px;
  height: 12px;
  cursor: pointer;
`;

const CalendarOuter = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;
`;

const CalendarWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 40px;
  z-index: 12;

  .react-calendar {
    width: 320px;
    max-width: 100%;
    background-color: #ffffff;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
    color: ${colors.primary};
    overflow: hidden;
  }

  .react-calendar__tile {
    padding: 0.75rem;
    background-color: ${colors.background};
    border: none;
    color: ${colors.primary};
  }

  .react-calendar__navigation {
    background-color: ${colors.primary};
    height: 52px;
  }

  .react-calendar__tile--active {
    background-color: ${colors.primaryLight};
  }

  .react-calendar__tile--hover {
    background-color: ${colors.lightBlue};
  }

  .react-calendar__navigation__arrow {
    width: 20px;
    color: ${colors.white};

    &:hover {
      background-color: ${colors.primaryLight} !important;
    }
  }

  .react-calendar__navigation__label {
    color: ${colors.white};

    &:hover {
      background-color: ${colors.primaryLight} !important;
    }
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export default function BillingDetails() {
  const [date, setDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  useEffect(() => {
    fetchData();
  }, [date]);

  const fetchData = async () => {
    try {
      const startDate = Array.isArray(date)
        ? moment(date[0]).format("YYYY-MM-DD")
        : null;
      const endDate = Array.isArray(date)
        ? moment(date[1]).format("YYYY-MM-DD")
        : null;

      console.log(date, startDate, endDate, typeof date);
      setIsLoading(true);
      setShowCalendar(false);
      const data = await getAllTransactions(startDate, endDate);
      setResults(data?.data?.results);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const handleDownload = (link) => {
    window.open(link, "_blank");
  };

  return (
    <>
      <Content>
        <ContentHeader>
          <Row>
            <HeaderIcon src={Icon} />
            <TextView variant="title">Billing Information</TextView>
          </Row>
          <Row
            style={{ cursor: "pointer" }}
            onClick={() => setShowCalendar(!showCalendar)}
          >
            <CalendarTodayIcon style={{ opacity: 0.6 }} />
            <TextView
              style={{
                marginRight: 5,
                marginLeft: 5,
                opacity: 0.6,
              }}
            >
              By Date
            </TextView>
            <ExpandMoreIcon style={{ opacity: 0.6 }} />
          </Row>
        </ContentHeader>
        {showCalendar && (
          <>
            <CalendarWrapper>
              <Calendar onChange={setDate} value={date} selectRange={true} />
            </CalendarWrapper>
          </>
        )}
        
        {!isLoading && (
          <TableWrapper>
            <Table>
              <thead>
                <TableRow>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Plan</TableHeader>
                  <TableHeader>Amount</TableHeader>
                  <TableHeader style={{ textAlign: "center" }}>
                    Download Invoice
                  </TableHeader>
                </TableRow>
              </thead>
              <tbody>
                {results.map((row, index) => (
                  <TableRow key={index}>
                    <DateCell>
                      {moment(row.date).format("MMM DD, YYYY")}
                    </DateCell>
                    <PlanCell>{"Monthly"}</PlanCell>
                    <AmountCell>${row.amount / 100}</AmountCell>
                    <DownloadCell>
                      <DownloadIcon
                        src={ASSETS.download}
                        onClick={() => handleDownload(row.invoice_url)}
                      />
                    </DownloadCell>
                  </TableRow>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        )}
      </Content>
      {showCalendar && <CalendarOuter onClick={() => setShowCalendar(false)} />}
    </>
  );
}
